import { peopleList } from '@/mocks/blackMaterial';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

export default function PeopleGrid() {
  return (
    <section id="qidi" className="scroll-mt-28 mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
      <Reveal>
        <SectionHeading
          kicker="WHO · 人物起底"
          title="人物深挖 · 起底进行时"
          desc="不针对个人生活私隐，只拆解公开履历、台前口径与商业行为之间对不上的地方。时间线还原 + 证据编号，让起底有据可查。"
        />
      </Reveal>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {peopleList.map((p, idx) => (
          <Reveal key={p.id} delay={idx * 60}>
            <article className="group relative flex h-full flex-col overflow-hidden rounded-lg bg-white ring-1 ring-[#e6dbc9] transition hover:-translate-y-1 hover:ring-[#c83424]">
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={
                    p.id === 1
                      ? 'https://readdy.ai/api/search-image?query=shadowy%20silhouette%20of%20a%20streamer%20in%20front%20of%20a%20stack%20of%20boxes%2C%20cold%20led%20studio%20lighting%2C%20dark%20editorial%20photography%2C%20documentary%20grain%2C%20warm%20brown%20and%20ink%20tones%2C%20mysterious%20moody%20composition&width=640&height=400&seq=person01-x1&orientation=landscape'
                      : p.id === 2
                      ? 'https://readdy.ai/api/search-image?query=dim%20concert%20stage%20backstage%20silhouette%20with%20spotlight%20and%20sound%20equipment%2C%20dark%20warm%20editorial%20photography%2C%20film%20grain%2C%20moody%20documentary%20feel%20in%20charcoal%20and%20amber&width=640&height=400&seq=person02-x1&orientation=landscape'
                      : p.id === 3
                      ? 'https://readdy.ai/api/search-image?query=close%20up%20of%20torn%20concert%20tickets%20and%20fan%20merchandise%20on%20dark%20wood%2C%20moody%20editorial%20still%20life%2C%20warm%20ink%20tones%2C%20documentary%20grain&width=640&height=400&seq=person03-x1&orientation=landscape'
                      : p.id === 4
                      ? 'https://readdy.ai/api/search-image?query=contract%20documents%20with%20wax%20seal%20and%20pen%20on%20desk%2C%20dramatic%20shadow%2C%20dark%20warm%20editorial%20photography%2C%20moody%20documentary%20grain&width=640&height=400&seq=person04-x1&orientation=landscape'
                      : p.id === 5
                      ? 'https://readdy.ai/api/search-image?query=broken%20mirror%20reflection%20with%20hazy%20figure%2C%20dark%20editorial%20conceptual%20photography%2C%20warm%20sepia%20and%20ink%20tones%2C%20moody%20atmosphere&width=640&height=400&seq=person05-x1&orientation=landscape'
                      : 'https://readdy.ai/api/search-image?query=ledger%20books%20and%20calculator%20under%20dim%20lamp%20with%20long%20shadows%2C%20dark%20warm%20editorial%20photography%2C%20documentary%20grain%2C%20charcoal%20and%20gold%20tones&width=640&height=400&seq=person06-x1&orientation=landscape'
                  }
                  alt={`${p.name}起底封面`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1c140c]/70 via-transparent to-transparent"></div>
                <span className="absolute left-3 top-3 rounded bg-white/90 px-2 py-0.5 text-[11px] font-semibold text-[#262019]">
                  {p.field}
                </span>
                <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
                  <span className="font-display text-xl font-black text-white drop-shadow">{p.name}</span>
                  <span className="rounded bg-[#c83424]/90 px-2 py-0.5 text-[11px] font-semibold text-white">
                    {p.role}
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <p className="text-[13px] leading-6 text-[#5d5245]">{p.summary}</p>
                <div className="mt-4 flex flex-wrap items-center gap-1.5">
                  {p.tags.map((t) => (
                    <span key={t} className="rounded-full bg-[#f0e8d8] px-2.5 py-0.5 text-[11px] font-medium text-[#6b5f51]">
                      #{t}
                    </span>
                  ))}
                </div>
                <div className="mt-4 flex items-center justify-between border-t border-[#eadfd0] pt-3 text-xs text-[#9a8a75]">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-fill text-[#e8603c]"></i>热度 <b className="text-[#b0392a]">{p.hot}</b>
                  </span>
                  <span className="flex cursor-pointer items-center gap-1 font-semibold text-[#c83424]">
                    查看起底档案 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}